import { alpha, createTheme } from '@mui/material';

import { Colors } from '@constants/colors.constants';

import fonts from '@fonts/index';

import appBar from '@theme/appBar.theme';
import buttons from '@theme/buttons.theme';
import cards from '@theme/card.theme';
import chip from '@theme/chip.theme';
import dialog from '@theme/dialog.theme';
import drawer from '@theme/drawer.theme';
import inputs from '@theme/inputs.theme';
import menu from '@theme/menu.theme';
import palette from '@theme/palette.theme';
import tabs from '@theme/tabs.theme';
import typography from '@theme/typography.theme';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    mobile: true;
    tablet: true;
    laptop: true;
    desktop: true;
  }
}

const theme = createTheme({
  palette,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      mobile: 0,
      tablet: 1100,
      laptop: 1024,
      desktop: 1200,
    },
  },
  typography: {
    fontFamily: 'CircularStd, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `${fonts}
        html {
          height: 100%;
          -webkit-font-smoothing: auto;
        }
        body {
          height: 100%;
          scrollbar-color: ${Colors.primary} ${alpha(Colors.primary, 0.1)};
          scrollbar-width: thin;
        }
        .scrollable {
          mask-image: linear-gradient(
            to bottom,
            transparent,
            white 20px,
            white calc(100% - 20px),
            transparent
          );
        }
				div#root {
					height: 100%;
				}
        *::-webkit-scrollbar {
          height: 8px;
          width: 8px;
        }
        *::-webkit-scrollbar-track {
          background-color: ${alpha(Colors.primary, 0.1)};
          border-radius: 4px;
          margin: 15px;
        }
        *::-webkit-scrollbar-thumb {
          background-color: ${Colors.primary};
          border-radius: 4px;
        }`,
    },
    ...appBar,
    ...drawer,
    ...typography,
    ...buttons,
    ...tabs,
    ...inputs,
    ...cards,
    ...menu,
    ...dialog,
    ...chip,
  },
});

export default theme;
